export default __webpack_public_path__ + "static/media/flag_chi.528f4b29.svg";